import { UserInterfaceDto } from "../../dtos/user-interfaces";
import { WidgetDto } from "../../dtos/widgets";
import { RecursivePartial } from "../../utils";

import {
  ResolvedWidgetDeviceConfigType,
  WidgetConfigType,
  WidgetDeviceConfigType,
} from "./common";
import { TypographySettings } from "./quantity-buttons-widget";

export interface MessageBoxStyles {
  // image: {
  //   width: string;
  // };
  // content: {
  //   padding: string;
  // };
  container: {
    textColor: string;
    backgroundColor: string;
    cornerRadius: string;
    // padding: string;
    // display: string;
    // boxShadow: string;
    // titleFontSize: string;
    // titleFontWeight: string;
    // bodyFontSize: string;
    // bodyFontWeight: string;
    // fontWeight: string;
    // zIndex: string;
    // width: string;
    // height: string;
    // top: string;
    // left: string;
  };
  placement: string;
  typography: {
    title: TypographySettings;
    description: TypographySettings;
  };
}

export const MessageBoxWidgetVariantList = [
  "messageBoxPopupWidget1",
  "messageBoxSlideOutWidget1",
] as const;
export type MessageBoxVariant = (typeof MessageBoxWidgetVariantList)[number];

export const MESSAGE_BOX_VARIANT_NAMES: Record<MessageBoxVariant, string> = {
  messageBoxPopupWidget1: "Popup",
  messageBoxSlideOutWidget1: "Slide out",
};

export interface MessageBoxVariables {
  textReplacements: {
    title: string;
    body: string;
  };
  image: string;
}

export interface MessageBoxWidgetDto extends WidgetDto {
  widgetType: "messageBoxPopup" | "messageBoxSlideOut";
  config: MessageBoxWidgetConfig;
}

export type MessageBoxWidgetConfig = WidgetConfigType<
  MessageBoxVariant,
  MessageBoxStyles,
  MessageBoxVariables
>;

export type MessageBoxDeviceConfig = WidgetDeviceConfigType<
  MessageBoxVariant,
  MessageBoxStyles,
  MessageBoxVariables
>;

export type ResolvedMessageBoxDeviceConfig = ResolvedWidgetDeviceConfigType<
  MessageBoxVariant,
  MessageBoxStyles,
  MessageBoxVariables
>;

export interface MessageBoxUserInterface
  extends Omit<
    UserInterfaceDto,
    "widget" | "desktopVariables" | "mobileVariables"
  > {
  widget?: MessageBoxWidgetDto;
  desktopVariables?: RecursivePartial<MessageBoxVariables>;
  mobileVariables?: RecursivePartial<MessageBoxVariables>;
}

export interface MessageBoxConfig {
  id: string;
  widget: MessageBoxWidgetConfig;
}

export interface IgDiscountMessageBoxProps {
  config: MessageBoxConfig;
}

export interface MessageBoxWidgetType {
  updateOrBuild(): Promise<boolean>;
}
